<template>
  <div class="check-work-body">
    <div style="display: flex;flex-direction: row">
      <div style="width: 200px">
        <area-tree @nodeClick="nodeClick1"></area-tree>
      </div>
      <div>
        <div class="search-wrap">
          <!--          <el-button size="mini" type="primary" @click="editArticle()" style="margin-right: 5px;" icon="el-icon-plus">添加</el-button>-->
          <el-form :inline="true">
            <el-form-item>
              <el-input size="mini" placeholder="客户名称/项目名称/发票号" v-model="keyword" clearable style="width: 200px"></el-input>
            </el-form-item>
            <el-form-item>
              <el-select size="mini" v-model="time_type" placeholder="筛选类型">
                <el-option label="合同月份" value="contract_month"></el-option>
                <el-option label="开票时间" value="invoice_type"></el-option>
              </el-select>
              <div v-if="time_type === 'contract_month'" style="float:right;">
                <el-date-picker
                size="mini"
                  v-model="start_month"
                type="month"
                format="yyyy-MM"
                value-format="yyyy-MM"
                placeholder="选择月">
                </el-date-picker> -
                <el-date-picker
                  size="mini"
                  v-model="end_month"
                  type="month"
                  format="yyyy-MM"
                  value-format="yyyy-MM"
                  placeholder="选择月">
              </el-date-picker>
              </div>
              <el-date-picker v-else
                size="mini"
                v-model="invoice_time"
                type="daterange"
                format="yyyy-MM-dd"
                value-format="yyyy-MM-dd"
                placeholder="选择日期">
              </el-date-picker>
            </el-form-item>
            <el-form-item>
              <el-select size="mini" v-model="entry_type_name" placeholder="业务类型" clearable>
                <el-option
                  v-for="item in business_list"
                  :key="item.id"
                  :label="item.name"
                  :value="item.name">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-select size="mini" v-model="check_status" placeholder="审核状态">
                <el-option
                  v-for="item in [{'name':'全部','value':''},{'name':'未审','value':'0'},{'name':'已审','value':'1'}]"
                  :key="item.name"
                  :label="item.name"
                  :value="item.value">
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" type="primary" @click="search">搜索</el-button>
            </el-form-item>
            <el-form-item>
              <el-button size="mini" @click="Api.downloadIncomeTemplate(search_params)">导出模板</el-button>
            </el-form-item>
            <el-form-item>
              <el-upload :action="upload_url" :on-success="uploadComplete" :file-list="upload_file_list">
                <el-button size="mini">导入收款</el-button>
              </el-upload>
            </el-form-item>
            <el-form-item>
              <el-button @click="showBankIncomeDialog">银行流水</el-button>
            </el-form-item>
          </el-form>

          <!--          <el-button size="mini" type="primary" v-if="multipleSelection.length" @click="invoices()">开发票</el-button>-->
          <!--          - -->
          <!--          <el-button size="mini" type="primary" @click="exportExcel">导出</el-button>-->
          <!--          <el-button size="mini" type="primary" @click="importExcel">导入</el-button>-->
        </div>

        <div class="table-wrap">
          <el-table v-if="pageData" v-loading="loading" :data="pageData.list" @selection-change="handleSelectionChange" height="680px">
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column prop="party_a" label="客户名称" align="center" width="200"></el-table-column>
            <el-table-column prop="project_name" label="项目名称" align="center" width="200"></el-table-column>
            <el-table-column prop="entry_type_name" label="业务类型" align="center" width="80"></el-table-column>
            <el-table-column prop="month" label="应收月份" width="100" align="center"></el-table-column>
            <el-table-column prop="amount" label="合同金额" align="center"></el-table-column>
            <el-table-column prop="invoice_amount" label="应收金额" align="center"></el-table-column>
            <el-table-column prop="invoiced_amount" label="开票金额" align="center"></el-table-column>
            <el-table-column prop="invoice_ticket_no" label="发票号" align="center"></el-table-column>
            <el-table-column prop="income_amount" label="回款金额" align="center"></el-table-column>
            <el-table-column prop="owe_amount" label="欠款金额" align="center">
              <template slot-scope="scope">
                <span style="color: #28af05">{{toRound(scope.row.owe_amount)}}</span>
              </template>
            </el-table-column>
            <el-table-column prop="project_leader" label="负责人" align="center"></el-table-column>
            <el-table-column prop="invoice_type" label="发票类型" align="center"></el-table-column>
            <el-table-column label="开票时间" prop="invoice_date" align="center"></el-table-column>
            <el-table-column prop="status" label="发票是否审核" align="center">
              <template slot-scope="scope">
                <el-tag size="mini" :type="scope.row.invoice_check_status>0?'success':'danger'">{{scope.row.invoice_check_status>0?'已审':'未审'}}</el-tag>
              </template>
            </el-table-column>
            <el-table-column label="操作 " align="center">
              <template slot-scope="scope">
                <el-button type="primary" size="mini" v-if="ERP.isPermission(26005002003002)" icon="el-icon-edit" @click="income(scope.row)">收款</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>

        <div class="pagination-wrap">
          <el-pagination background layout="prev, pager, next" :total="pageData.total*1" :page-size="pageData.pageSize*1" :current-page="pageData.page*1" @current-change="pageChange"></el-pagination>
        </div>
      </div>
    </div>

    <!-- 修改窗口 -->
    <el-dialog title="收款登记" :visible.sync="dialogVisible" :close-on-click-modal="false">

      <div style="max-height: 500px;overflow-y: auto;">
        <el-form :model="form" ref="form" :rules="rules" label-width="100px" size="mini" style="margin-right: 50px;">
          <el-form-item label="发票类型" prop="invoice_type">
            <el-select disabled v-model="form.invoice_type" placeholder="发票类型" clearable>
              <el-option
                v-for="item in [
                  {'name':'专用发票'},
                  {'name':'普通发票'},
                  {'name':'电子普票'},
                  {'name':'电子专票'}
                ]"
                :key="item.name"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="回款性质" prop="income_type">
            <el-select v-model="form.income_type" placeholder="回款性质" clearable>
              <el-option
                v-for="item in [{'name':'当期'},{'name':'历史'}]"
                :key="item.name"
                :label="item.name"
                :value="item.name">
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="发票票号" prop="title">
            <el-input class="form-input" disabled v-model="form.ticket_no" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="各项金额" prop="title">
            <el-table :data="multipleSelection">
              <el-table-column prop="party_a" label="客户名称" align="center" width="120"></el-table-column>
              <el-table-column prop="project_name" label="项目名称" align="center" width="120"></el-table-column>
              <el-table-column prop="entry_type_name" label="业务类型" align="center" width="90"></el-table-column>
              <!--              <el-table-column prop="name" label="费项名称" align="center" width="120"></el-table-column>-->
              <el-table-column prop="month" label="应收月份" width="100" align="center"></el-table-column>
              <el-table-column prop="amount" label="合同金额" align="center"></el-table-column>
              <el-table-column prop="invoiced_amount" label="开票金额" align="center"></el-table-column>
              <el-table-column prop="income_amount" label="已回款金额" align="center"></el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="收款金额" prop="amount">
            <el-input class="form-input" v-model="form.amount" autocomplete="off"></el-input>
          </el-form-item>
          <el-form-item label="收款时间" prop="income_time">
            <el-date-picker
              v-model="form.income_time"
              type="date"
              format="yyyy-MM-dd"
              value-format="yyyy-MM-dd"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="附件" prop="title">
            <upload-files-sysc :host-url="host_url" :upload-url="host_url+'/contract/project/uploadFile'"  :limit="20" v-model="form.files"></upload-files-sysc>
          </el-form-item>
          <el-form-item label="备注" prop="remarks">
            <el-input
              type="textarea"
              placeholder="请输入内容"
              v-model="form.remarks"
              maxlength="100"
              show-word-limit
            >
            </el-input>
          </el-form-item>
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitForm('form')" >确 定</el-button>
      </div>
    </el-dialog>

    <el-dialog title="收款列表" :visible.sync="incomeListVisible" width="80%">
        <el-button type="primary" @click="incomeForm">收款登记</el-button>
        <el-table :data="incomeList">
          <el-table-column prop="name" label="名称"></el-table-column>
          <el-table-column prop="income_type" label="类型"></el-table-column>
          <el-table-column prop="income_amount" label="回款金额"></el-table-column>
          <el-table-column prop="income_time" label="回款日期"></el-table-column>
          <el-table-column label="操作" width="380px">
            <template slot-scope="scope">
              <el-button size="mini" v-if="ERP.isPermission(26005002003002)" :disabled="scope.row.income_check_status > 0" type="primary" @click="updateIncome(scope.row)">修改</el-button>
              <el-button size="mini" v-if="ERP.isPermission(26005002003001)" :disabled="scope.row.income_check_status > 0" @click="checkIncome(scope.row)">审核</el-button>
              <el-button size="mini" v-if="ERP.isPermission(26005002003001)" :disabled="scope.row.income_check_status < 1" @click="checkIncome(scope.row)">反审核</el-button>
              <el-button size="mini" v-if="ERP.isPermission(26005002003002)" :disabled="scope.row.income_check_status > 0" type="danger" @click="delIncome(scope.row.income_id)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
    </el-dialog>

    <!-- 银行流水对话框 -->
    <bank-income
      :visible.sync="bankIncomeVisible"
      :selected-invoices="multipleSelection"
      @close="handleBankIncomeClose"
      @match-success="handleMatchSuccess"
    ></bank-income>

  </div>
</template>

<script>

import CommonHelp from "./common/CommonHelp";
import ApiHelp from './common/Api';
import UploadFilesSysc from "./components/UploadFilesSysc";
import AreaTree from "./components/AreaTree";
import Api from "./common/Api";
import {Message} from "element-ui";
import moment from "moment";
import BankIncome from "./BankIncome.vue";

export default {
  name:"ContractFinanceIncome",
  components: {AreaTree, UploadFilesSysc, BankIncome},
  data () {
    var validateAmount=(rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入登记金额'));
      }else if(value<=0){
        callback(new Error('金额必须大于0'));
      }else {
        callback();
      }
    };
    return {
      host_url:"",
      keyword: '',
      loading: false,
      contract_area_id:'',
      pageData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      pageChannelData:{
        list:[],
        total:0,
        pageSize:20,
        page:1
      },
      dialogVisible:false,
      rules: {
        income_type: [
          { required: true, message: '请选择回款性质', trigger: 'change' },
        ],
        amount: [
          { validator: validateAmount, required: true, trigger: 'blur' },
        ],
        income_time: [
          { required: true, message: '请选择回款时间', trigger: 'change' },
        ],
      },
      form:{
        name:"",
        invoice_type:"",
        income_type:"",
        ticket_no:"",
        finance_id:"",
        amount:0,
        income_time:"",
        files:"",
        status:true,
        remarks:"",
        invoice_id : 0,
      },
      uploadUrl:"",
      month_money_list:[],
      project_list:[],
      month_value:"",
      start_month : '',
      end_month : '',
      multipleSelection:[],
      check_status : '',
      time_type : 'contract_month',
      f_status:'2,3,4',
      business_list:[],
      invoice_time : [],
      entry_type_name:"",
      // 收款列表
      incomeRow : {},
      incomeList : [],
      incomeListVisible : false,
      upload_file_list : [],

      // 银行流水
      bankIncomeVisible: false,
    }
  },
  created() {
    this.host_url=CommonHelp.getBaseURL();
    this.upload_url = Api.getUploadUrl('/contract/FinanceIncome/batchIncome')
    this.start_month = CommonHelp.date("YYYY-MM");
    this.end_month = CommonHelp.date("YYYY-MM");
    // this.getList()
    this.getBusinessList()
    // 当前月第一天和最后一天
    let firstDay = moment().startOf('month').format("YYYY-MM-DD");
    let lastDay = moment().endOf('month').format("YYYY-MM-DD");
    this.invoice_time = [
      firstDay , lastDay
    ];
  },
  activated() {
    this.getList()
  },
  watch: {
    dialogVisible(val) {
      if(val == false) {
        this.multipleSelection = []
      }
    },
    "form.province_city_ids":function (n) {
      n&&n[0]&&(this.form.province_id=n[0])
      n&&n[1]&&(this.form.city_id=n[1])
      console.log(n)
    },
    "form.contract_area_ids":function (n) {
      console.log(n)
    },
    income_account(n){
      console.log('income_account',n);
    },
    finance_ids(n){
      console.log(n)
    },
    search_params(){
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      this.month_value&&(where.month=this.month_value);
      this.entry_type_name&&(where.entry_type_name=this.entry_type_name);
      where['f.status']=this.f_status;
      return where;
    },
  },
  computed:{
    Api() {
      return Api
    },
    income_account(){
      return this.multipleSelection.reduce(function(total, currentValue, currentIndex){
        total+=(currentValue.paid_amount*1);
        return total;
      }, 0)
    },
    finance_ids(){
      return this.multipleSelection.map(ret=>{return ret.id;})
    },
    search_params(){
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      if(this.time_type === 'contract_month'){
        where.start_month = this.start_month;
        where.end_month = this.end_month;
      }else{
        where.invoice_start_time = this.invoice_time[0];
        where.invoice_end_time = this.invoice_time[1];
      }
      this.entry_type_name&&(where.entry_type_name=this.entry_type_name);
      where['check_status']=this.check_status;
      return where;
    }
  },
  methods: {
    getFormData(data) {
      let defaultValue = {
        id:'',
        name:"",
        invoice_type:"",
        income_type:"",
        ticket_no:"",
        finance_id:"",
        amount:0,
        income_time:"",
        files:"",
        status:true,
        remarks:"",
      };
      // 查找对象中是否有对应值
      if (data) {
        Object.keys(defaultValue).forEach(key => {
          if (data[key]) {
            defaultValue[key] = data[key]
          }
        })
      }
      return defaultValue;
      //
      // return Object.assign({
      //   id:'',
      //   name:"",
      //   invoice_type:"",
      //   income_type:"",
      //   ticket_no:"",
      //   finance_id:"",
      //   amount:0,
      //   income_time:"",
      //   files:"",
      //   status:true,
      //   remarks:"",
      // }, data)
    },
    search() {
      this.pageData.page = 1
      this.getList()
    },
    getList() {
      var that=this;
      that.loading=true;
      CommonHelp.get("FinanceIncome/getInvoiceList",{
        where:JSON.stringify(this.search_params),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          res.data.list.map(ret=>{
            ret.is_end=ret.is_end === 1;
            ret.is_invoice=ret.is_invoice === 1;
            ret.is_paid=ret.is_paid === 1;
            // ret.paid_amount=ret.paid_amount>0?ret.paid_amount:ret.invoice_amount;
            return ret;
          })
          that.pageData=res.data
        }
        that.loading=false;
      })
    },
    pageChange(i) {
      this.pageData.page = i
      this.getList()
    },
    income(data) {
      this.incomeRow = data;
      this.incomeListVisible = true;
      let that = this;
      ApiHelp.incomeList({finance_id : data.id , 'ii.status' : 1 , 'i.id' : data.invoice_id} , 0 , 100 ,(res) => {
        that.incomeList = res.list;
      })
    },
    incomeForm(){
      let item=CommonHelp.reObject(this.incomeRow)
      this.multipleSelection=[item];
      this.incomes(item);
    },
    incomes(item){
      this.form = this.getFormData({})
      this.form.ticket_no=item.invoice_ticket_no;
      this.form.name=item.invoice_name;
      this.form.invoice_type=item.invoice_type;
      this.form.amount=(item.invoiced_amount-item.income_amount);
      this.form.finance_id=this.finance_ids[0];
      this.form.invoice_id = item.invoice_id;
      this.dialogVisible = true
    },
    // 修改回款
    updateIncome(row){
      this.form = this.getFormData(row);
      let item = CommonHelp.reObject(this.incomeRow);
      this.multipleSelection=[item];
      this.form.ticket_no=item.invoice_ticket_no;
      this.form.name=item.invoice_name;
      this.form.invoice_type=item.invoice_type;
      this.form.invoice_id = row.invoice_id;
      this.form.amount=row.income_amount;
      this.form.finance_id=this.finance_ids[0];
      this.form.id = row.income_id;
      this.form.status = 1;
      this.dialogVisible = true
    },
    // 删除回款
    delIncome(id) {
      let that = this;
      this.$confirm('确认删除吗？', '提示' , {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ApiHelp.incomeDel(id , res => {
          that.incomeListVisible = false;
          that.dialogVisible = false;
          that.getList();
        })
      })
    },

    submitForm(formName) {
      var that=this;
      that.$refs[formName].validate((valid) => {
        if (valid) {
          that.formLoading = true
          let data = Object.assign({}, this.form)
          if(data.amount>0){
            CommonHelp.post("FinanceIncome/save",data,res => {
              that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
              if(res.code) {
                that.incomeListVisible = false;
                that.dialogVisible = false;
                that.multipleSelection=[];
                that.getList()
              }
              that.formLoading = false
            })
          }else {
            that.$Message.error("请输入大于0的数");
          }
        } else {
          return false;
        }
      });
    },

    setFrom(data){
      var that=this;
      CommonHelp.post("FinanceInvoice/save",data,res => {
        that.$message({type: res.code === 1 ? 'success': 'error', message: res.msg})
        if(res.code) {
          that.multipleSelection=[];
          that.getList()
        }
      })
    },
    onAreaChange({data,pathData,ids}){
      this.form.province_city=data.mergename;
      this.form.province_city_ids=ids.join(',')
    },
    onContractAreaChange({data,pathData,ids}){
      let adrr=""
      pathData.map((ret,index)=>{
        adrr+=ret.name+(pathData[index+1]?' -> ':'')
      })
      this.form.contract_area=adrr;
      this.form.contract_area_ids=ids.join(',')
    },
    nodeClick1(n){
      this.contract_area_id=n.id;
      this.pageData={
        list:[],
        total:0,
        pageSize:20,
        page:1
      }
      this.getList()
    },
    exportExcel(){
      var that=this;
      let where={};
      this.keyword&&(where.name=this.keyword);
      this.contract_area_id&&(where.contract_area_ids=this.contract_area_id);
      CommonHelp.get("Finance/exportExcel",{
        where:JSON.stringify(where),
        page: this.pageData.page,
        page_size: this.pageData.pageSize
      },res=>{
        if(res.code) {
          window.open(that.host_url + res.data)
        }
      })
    },
    importExcel(){
      var that=this;
      CommonHelp.uploadFile(ret=>{
        // console.log(ret);
        CommonHelp.post("Finance/importExcel",{ file_name:ret },res=>{
          if(res.code) {
            that.getList();
            if(res.data&&res.data.length){
              that.error_show_status=true;
              that.error_list=res.data;
            }
          }else {
            this.$message(res.msg);
          }
        })
      });
    },
    getBusinessList(){
      var that=this;
      CommonHelp.get("Business/getList",{
        page: 1,
        page_size: 100
      },res=>{
        if(res.code) {
          that.business_list=res.data.list
        }
      })
    },
    selectable(row,index){
      // let is_paid=!!row.is_paid;
      let status = row.status === 3 || row.status === 2;
      let is_end =!row.is_end;
      return status && is_end;
    },
    toggleSelection(rows) {
      if (rows) {
        rows.forEach(row => {
          this.$refs.multipleTable.toggleRowSelection(row);
        });
      } else {
        this.$refs.multipleTable.clearSelection();
      }
    },
    handleSelectionChange(val) {
      console.log(val)
      this.multipleSelection = val;
    },
    checkIncome(row){
      var that=this;
      that.$confirm('是否确定操作？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        CommonHelp.post("FinanceIncome/check_status_change",{ids:row.income_id},res=>{
          if(res.code) {
            that.income(that.incomeRow);
          }else {
            that.$message({
              type: 'warning',
              message: res.msg||"请求异常"
            });
          }
        })
      }).catch(() => {
        that.$message({
          type: 'info',
          message: '已取消审核'
        });
      });
    },
    date(time){
      return CommonHelp.date("YYYY-MM-DD",time)
    },
    toRound(val){
      return Math.round(val*(100))/(100)
    },
    uploadComplete(res){
      if(res.code){
        Message.success(res.msg)
        this.upload_file_list = [];
        this.getList();
      }else{
        Message.error(res.msg);
      }
    },

    // 显示银行流水对话框
    showBankIncomeDialog() {
      this.bankIncomeVisible = true;
    },

    // 关闭银行流水对话框
    handleBankIncomeClose() {
      this.bankIncomeVisible = false;
    },

    // 匹对收款成功回调
    handleMatchSuccess() {
      // 清空勾选
      this.multipleSelection = [];
      // 重新加载数据
      this.getList();
      Message.success('匹对收款成功，数据已刷新');
    },
  }
}
</script>
<style lang="scss" scoped>

@import './common.scss';

.form-input {
  width: 300px;
}
.table-wrap{
  width: calc( 100vw - 120px - 230px );
  overflow-x: scroll;
}
</style>



// WEBPACK FOOTER //
// src/components/Admin/Contract/ContractFinanceIncome.vue